import { VVLIcon, ActivityIcon, CalendarIconDetail, ReportsIcon, SearchIcon } from "../../../../../shared/margincalculator/components/icons/Icon";
import "./VVL_List.scss";

const stats = [
  { 
    label: "Dringend (<30d)", 
    value: 0, 
    key: "urgent", 
    icon: <VVLIcon />,
    color: "red"
  },
  { 
    label: "Bald (30-60d)", 
    value: 0, 
    key: "soon", 
    icon: <ActivityIcon />,
    color: "orange"
  },
  { 
    label: "Vormerken (60-90d)", 
    value: 0, 
    key: "flagged", 
    icon: <CalendarIconDetail />,
    color: "green"
  },
  { 
    label: "Gesamt", 
    value: 0, 
    key: "total", 
    icon: <ReportsIcon />,
    color: "gray"
  }
];

export default function VVLList() {
  return (
    <div className="contracts">
      <header className="contracts__header">
        <div className="contracts__header-title">
          <div className="contracts__header-icon">
            <VVLIcon />
          </div>
          <div>
            <h1>VVL-Übersicht</h1>
            <p>Vertragsverlängerungen im Blick</p>
          </div>
        </div>
      </header>

      <section className="contracts__stats">
        {stats.map(stat => (
          <div key={stat.key} className={`stat-card stat-card--${stat.color}`}>
            <div className="stat-card__info">
              <span className="stat-card__label">{stat.label}</span>
              <span className="stat-card__value">{stat.value}</span>
            </div>
            <div className="stat-card__icon">
              {stat.icon}
            </div>
          </div>
        ))}
      </section>

      <section className="contracts__filters">
        <div className="contracts__filters-group">
          <div className="filter-select">
            <SearchIcon className="filter-select__icon" />
            <select>
              <option>Alle Netze</option>
            </select>
          </div>
          <div className="filter-select">
            <select>
              <option>Aktiv</option>
            </select>
          </div>
        </div>
      </section>

      <section className="contracts__empty">
        <div className="empty-state">
          <div className="empty-state__icon">
            <VVLIcon />
          </div>
          <h2 className="empty-state__title">Keine Verträge gefunden</h2>
          <p className="empty-state__text">
            Verträge können in der Kundenansicht hinzugefügt werden.
          </p>
          <button className="empty-state__button">
            Zur Kundenliste
          </button>
        </div>
      </section>
    </div>
  );
}
